import React from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import Articles from '../components/Articles';

const Home = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow">
                {/* Thank God I made it this far. */}
                <Articles />
            </div>
            <CustomFooter />
        </div>
    );
};

export default Home;